import type { FaireProductEntity } from "../../entity_types/product";

export const p_89qzhjw9yu: FaireProductEntity = {
  token: "p_89qzhjw9yu",
  type: "product",
  name: "Sleep Complex With Melatonin",
  brandToken: "b_838eh3fmdz",
  brandName: "Snap Supplements",
  imageUrl:
    "https://cdn.faire.com/fastly/04a9fafc029a65ed26f273545fa496af2b0c6ef8b5c113a68b539ab8c798ddba.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a890768e99dbcef562964b61a9c764d9f5a5aba5bdd4fabe518b6355503ac75.jpeg",
    "https://cdn.faire.com/fastly/289914ba530efd8192c66413e3e916f65cc005d760a17a82a464a75eb89f201c.jpeg",
    "https://cdn.faire.com/fastly/7a08a63c687a678e280eac77d880595013fbf0a145e0ca12be4e5762857a3d65.jpeg",
    "https://cdn.faire.com/fastly/241eebe694dd456c122d280d0064bb0a9c5cc90e16fc4ebd76f3fef51045cad5.jpeg",
    "https://cdn.faire.com/fastly/42dc4abe4a621b6e8214ee42df8baf4bceb3532b88bad9ab67725f6eb32deb21.jpeg",
    "https://cdn.faire.com/fastly/3ca9f8db8dea42115dd7ef2c13625ef81843191e9e6baf52fc6c922928b07336.jpeg",
    "https://cdn.faire.com/fastly/59f1489ed0545e1da88967fcf0ddb1689263c80c986a64057a23accf3caa8b76.jpeg",
  ],
  priceDollars: 16.2,
  description:
    "Regulate Circadian Rhythms with Restful Sleep\n\nSleep Complex promotes quality rest with natural herbs and minerals. Wake refreshed and restored with brain supporting compounds.*\n\n * Supports healthy sleep cycle* \n * Promotes restful sleep* \n * Supports healthy mood* \n * Aids relaxation* \n * Non-habit forming*",
  tags: [],
  msrpDollars: 22.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:41.610Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
